module.exports = __webpack_public_path__ + "img/choose-up-12_2 virtual.600e4367.png";